export default {
	created() {
		let resizeHandler = () => {
			if (typeof this.windowResized !== "function") {
				return;
			}
			this.windowResized({
				innerWidth: parseInt(window.innerWidth),
			});
		};
		resizeHandler();
		window.addEventListener("resize", _.debounce(resizeHandler, 350));
	}
};
